export { LazyLoader as MaterialCommunityIconsLoader } from './LazyLoader';
export { MaterialCommunityIcons } from './MaterialCommunityIcons';
